<template>
  <div></div>
</template>

<script>
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

export default {
  data() {
    return {
      code: '',
      state: '',
      loginLanguage: {}
    };
  },
  mounted() {
    this.code = this.$getQueryString('code');
    this.state = this.$getQueryString('state');
    this.init();
  },
  methods: {
    init: function () {
      if (!this.code || !this.state) {
        return;
      }
      if (this.state === 'login') {
        this.wechatLogin();
      }
      if (this.state === 'bind') {
        this.bindWechat();
      }
    },
    // 扫码登录
    wechatLogin: function () {
      this.$postJSON(`${apis.WechatLogin}/${this.code}`).then((res) => {
        if (res.code === 0) {
          if (!res.data.isNeedBinding) {
            const timeOut = Number(moment(Date.now()).format('X')) + res.data.token.expiresIn;
            Cookies.set('token', res.data.token.accessToken, { path: '/' });
            Cookies.set('tokenTimeOut', timeOut, { path: '/' });
            Cookies.set('nonMetric', res.data.nonMetric, { path: '/' });
            Cookies.set('langCode', res.data.userInfo.langCode || 'CN', { path: '/' }); // 记录站点
            this.$store.commit('USERINFO', Object.assign({ timeZoneName: res.data.timeZoneName, timeZone: res.data.timeZone }, res.data.userInfo));
            this.$store.commit('TIMEZONE', res.data.timeZone);
            this.$store.commit('TIMEZONEID', res.data.timeZoneId);
            this.$store.commit('DATEFORMAT', res.data.dateFormat);
            this.$store.commit('ISTIME24H', res.data.isTime24h);
            this.jump('/');
          }
        } else if (res.code === 408) {
          this.jump('/bindaccount', { userAuthId: res.data }, true);
        }
      });
    },
    // 扫码绑定
    bindWechat: function () {
      this.$postJSON(apis.ThirdPartyBind, { code: this.code, provider: 'weixin' }).then(() => {
        this.jump('/userset', { tab: 'bind' }, true);
      });
    }
  }
};
</script>

<style lang="scss"></style>
